<template>
  <div class="user_box">
    <h3 class="user_box--name">
      <span class="user_box--name--part">{{ userStat.first_name }}</span>
      <span class="user_box--name--part">{{ userStat.last_name }}</span>
    </h3>

    <div class="user_box--sections">
      <!-- Inbox -->
      <div class="user_box--section">
        <h4 class="user_box--section--heading">Inbox</h4>

        <div class="flex flex-centered">
          <div class="user_box--section--stat">
            <p class="user_box--section--stat--count">{{ userStat.unaddressed_inbox_leads_count }}</p>
            <p class="user_box--section--stat--label">New Leads</p>
          </div>
          <div class="user_box--section--stat">
            <p class="user_box--section--stat--count">{{ userStat.unaddressed_inbox_response_count }}</p>
            <p class="user_box--section--stat--label">Responses</p>
          </div>
        </div>
      </div>

      <div class="user_box--divider"/>

      <!-- Leads -->
      <div class="user_box--section">
        <h4 class="user_box--section--heading">Past Due Leads</h4>

        <div class="flex flex-centered">
          <div class="user_box--section--stat">
            <p class="user_box--section--stat--count">{{ userStat.past_due_contact_not_made_count }}</p>
            <p class="user_box--section--stat--label">Contact Not Made</p>
          </div>
          <div class="user_box--section--stat">
            <p class="user_box--section--stat--count">{{ userStat.past_due_manual_follow_count }}</p>
            <p class="user_box--section--stat--label">Manual Follow</p>
          </div>
        </div>
      </div>

      <div class="user_box--divider"/>

      <!-- Tasks -->
      <div class="user_box--section">
        <h4 class="user_box--section--heading">Tasks</h4>

        <div class="flex flex-centered">
          <div class="user_box--section--stat">
            <p class="user_box--section--stat--count">{{ userStat.past_due_tasks_count }}</p>
            <p class="user_box--section--stat--label">Past Due</p>
          </div>
          <div class="user_box--section--stat">
            <p class="user_box--section--stat--count">{{ userStat.tasks_completed_late_count }}</p>
            <p class="user_box--section--stat--label">Completed Late this Month</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatsAccountUserBox",
  props: {
    userStat: {
      type: Object,
      required: true
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.user_box {
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid $border;

  &:hover {
    background-color: $background; // same color that tables use for hover effect
  }

  @media (min-width: 1380px) {
    display: flex;
    align-items: center;
  }

  &--name {
    margin-bottom: 10px;
    font-size: 1.125rem;
    font-weight: bold;

    @media (min-width: 1380px) {
      min-width: 140px;
      margin-bottom: 0;
    }

    &--part {
      @media (min-width: 1380px) {
        display: block;
        line-height: 1.3;
      }
    }
  }

  &--sections {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    align-items: stretch;
  }

  &--divider {
    border-left: 1px solid $border;
  }

  &--section {
    width: 30%;

    &--heading {
      margin-bottom: 6px;
      font-size: 0.875rem;
      color: $text-light;
      text-align: center;
      text-transform: uppercase;
    }

    &--stat:not(:last-child) {
      margin-right: 20px;
    }

    &--stat--label {
      font-size: 0.75rem;
      text-align: center;
    }

    &--stat--count {
      font-size: 30px;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
